// Copyright (c) 2019 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import type { JSX } from "react";
import { connect } from "react-redux";
import { Dropdown as BSDrowdown } from "react-bootstrap";

import { isSet } from "shared/utils/utils";
import { IState } from "states/states";
import { IAction } from "actions";

interface IDropdownExtProps {
  caption?: string;
  curItem: string | JSX.Element | undefined;
  items: JSX.Element[];
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  isHeaderStyle?: boolean;
}

interface IDropdownProps {}

const mapStateToProps = (state: IState) => {
  const props: IDropdownProps = {};
  return props;
};

interface IDropdownDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IDropdownDispatch = {};
  return dispatchProps;
};

class DropdownComponent extends React.Component<
  IDropdownProps & IDropdownExtProps & IDropdownDispatch
> {
  public render() {
    return (
      <BSDrowdown
        className={[
          this.props.className,
          this.props.disabled ? "disabled" : "",
          this.props.isHeaderStyle ? "btn-header" : "",
        ]
          .filter(Boolean)
          .join(" ")}
        drop="down-centered"
      >
        <BSDrowdown.Toggle
          variant="secondary"
          style={this.props.style}
          className={[this.props.className, this.props.disabled ? "disabled" : ""]
            .filter(Boolean)
            .join(" ")}
        >
          {this.props.curItem ? this.props.curItem : this.props.caption}
        </BSDrowdown.Toggle>
        <BSDrowdown.Menu align="start" flip={true}>
          {isSet(this.props.caption) && (
            <BSDrowdown.Item className="dropdown-caption" disabled>
              {this.props.caption}
            </BSDrowdown.Item>
          )}
          {this.props.items}
        </BSDrowdown.Menu>
      </BSDrowdown>
    );
  }
}

const CustomDropdown = connect(mapStateToProps, mapDispatchToProps)(DropdownComponent);

export default CustomDropdown;
